import {
  Controller
} from "@hotwired/stimulus"
// import $ from 'jquery';
// import 'select2/dist/css/select2.min.css'
import Select2 from "select2"

export default class extends Controller {
  connect() {
    Select2()

    if ($('#advanced-search').length > 0) {
      $('.select').select2({
        width: '100%',
        dropdownParent: $('#advanced-search'),
      });
    } else {
      $('.select').select2({
        width: '100%',
        // select 移除搜尋功能
        minimumResultsForSearch: -1,
      });
    }

    $(document).on('select2:open', () => {
      document.querySelector('.select2-search__field').focus();
    });

    $("#linkCategory").on('select2:select', function (e) {
      if (e.params.data.id == 1) {
        $("#articleSelect").removeClass("d-none");
        $("#outsideLink").addClass("d-none");
      } else {
        $("#articleSelect").addClass("d-none");
        $("#outsideLink").removeClass("d-none");

        if (e.params.data.id == 3) {
          //最新消息範例
          $("#menuLink_zh").val("/zh-TW/news");
          $("#menuLink_en").val("/en/news");
        }

      }
    });

    $('#schedule_designer_id').on('select2:select', function (e) {
      let id = e.params.data.id;
      if (id) {
        $("#is-designer").addClass("d-none");
      } else {
        $("#is-designer").removeClass("d-none");
      }

    });
  }
}